import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import moment from 'moment';
import 'moment/locale/fr';

const useStyles = makeStyles({
  root: {
    padding: '7px 17px',
    cursor: 'pointer',
    borderRadius: 8,
    marginRight: 15
  },
  icon: {
    fontSize: 18
  },
  textContainer: {
    marginRight: 15
  },
  text: {
    fontSize: 16,
    marginLeft: 8
  },
  onDark: {
    color: '#A8B4D2',
  },
})

const SelectDate = ({ onClick, open, start, end, formatDate, placeholder, active, language, init }) => {
  const classes = useStyles();

  const dateToString = date => {
      if (language === 'FR') {
        moment.locale('fr');
        return  moment(start).format('DD MMM YYYY');
      };
      return formatDate(date).toString();
  };

  return (
      <Box 
        onClick={onClick} 
        display="flex" 
        alignItems="center" 
        justifyContent="space-between"
        className={clsx(classes.root, active? classes.active: '')}>
          <Box 
            display="flex" 
            alignItems="flex-start" 
            className={classes.textContainer}>
              <Typography className={clsx(classes.text, classes.onDark)}>
                  { !init
                      ? start 
                        ? end
                          ? `${dateToString(start)} - ${dateToString(end)}`
                          : dateToString(start)
                        : placeholder
                      : placeholder
                      }
              </Typography>
          </Box>
          <Box display="flex">
            <img 
              src={
                open
                  ? `${process.env.PUBLIC_URL}/icons/uparrow.svg`
                  : `${process.env.PUBLIC_URL}/icons/upsidedownarrow.svg`
                } 
              alt="icon" 
            />
          </Box>
      </Box>
  );
}

export default SelectDate;